<template>
  <div class="home">
    <h1>Welcome to Horse Racing</h1>
    <router-link to="/horse-race" class="button button--link home--play-button"
      >Play the Game</router-link
    >

    <div class="home--game-info">
      <h2>Game Information</h2>
      <p>
        This is a simple horse racing game where you can watch the race and see
        the results. The performance of each horse is random, so you never know
        who will win. Enjoy the game!
      </p>

      <small>
        For best User Experience Play on your mobile or laptop, I have not got
        time for fixing the tablet view as using custom CSS
      </small>
    </div>
  </div>
</template>
